'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { ChevronDown } from 'lucide-react';

interface FooterItem {
  name: string;
  url: string;
}

interface FooterProps {
  topIIMsCol1: FooterItem[];
  topIIMsCol2: FooterItem[];
  topIITs: FooterItem[];
  mbaCities: FooterItem[];
  mbaStates: FooterItem[];
  studyAbroad: FooterItem[];
  exams: FooterItem[];
}

const Section = ({ title, children, className }: { title: string; children: React.ReactNode, className?: string }) => (
  <div className={`flex flex-col gap-2 text-white text-sm ${className}`}>
    <div className="font-semibold text-base mb-2">{title}</div>
    {children}
  </div>
);

const FooterLinkList = ({ items }: { items: FooterItem[] }) => (
  <>
    {items.map((item, idx) => (
      <Link key={idx} href={`/${item.url}`}>
        <span className="line-clamp-2 text-sm hover:underline">{item.name}</span>
      </Link>
    ))}
  </>
);

const ListData = ({
  topIIMsCol1,
  topIIMsCol2,
  topIITs,
  mbaCities,
  mbaStates,
  studyAbroad,
  exams,
}: FooterProps) => {


  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const toggleMobile = () => setIsMobileOpen(!isMobileOpen);

  return (
    <div className="w-full">
      {/* Desktop View */}
      <div className="hidden md:grid grid-cols-5 gap-x-4 md:mt-8">
        {/* Top IIMs - Split into 2 columns */}
        <div className='flex  justify-between'>
        <Section title="Top IIMs">
          <FooterLinkList items={topIIMsCol1} />
        </Section>
        <Section title="" className='mt-6'>
          <FooterLinkList items={topIIMsCol2} />
        </Section>
        </div>

        <Section title="Top IITs" className='ml-16'>
          <FooterLinkList items={topIITs} />
        </Section>

        <Section title="MBA Colleges (Cities)">
          <FooterLinkList items={mbaCities} />
        </Section>

        <Section title="MBA Colleges (States)">
          <FooterLinkList items={mbaStates} />
        </Section>

        <Section title="Study Abroad" className='ml-8'>
          <FooterLinkList items={studyAbroad} />
          <div className="mt-3 font-semibold text-base mb-2">Exams</div>
          <FooterLinkList items={exams} />
        </Section>
      </div>

      {/* Mobile View - Accordion Style */}
      <div className="md:hidden space-y-4 mt-4">
        {[
          { title: 'Top IIMs', items: [...topIIMsCol1, ...topIIMsCol2] },
          { title: 'Top IITs', items: topIITs },
          { title: 'MBA Colleges (Cities)', items: mbaCities },
          { title: 'MBA Colleges (States)', items: mbaStates },
          { title: 'Study Abroad', items: studyAbroad },
          { title: 'Exams', items: exams },
        ].map((section, idx) => {
          const [open, setOpen] = useState(false);
          return (
            <div key={idx} className="border-b border-gray-600">
              <button
                onClick={() => setOpen(!open)}
                className="flex items-center justify-between w-full text-white font-medium py-2"
              >
                <span>{section.title}</span>
                <ChevronDown className={`transition-transform ${open ? 'rotate-180' : ''}`} />
              </button>
              {open && (
                <div className="pl-2 py-2 flex flex-col gap-2">
                  <FooterLinkList items={section.items} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListData;


